import { Alert, Box, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'

function MaxRecordsBanner({ open }: { open: boolean }) {
    if (!open) {
        return <></>
    }
    return (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mt={3}>
            <Typography variant='caption' >
                {t('analytics:maxRecords')}
            </Typography>
        </Box>

    )
}

export default MaxRecordsBanner